import styled from "styled-components";

export const Img = styled.img`
    width: ${p => p.w};
    height: ${p => p.h};
`